import FrameworkScorecard from "@/components/FrameworkScorecard";
import { STANDARDS } from "@/constants/testIds";
import { Rocket } from "lucide-react";

export default function LstpScorecard({ periodId }) {
  return (
    <FrameworkScorecard
      periodId={periodId}
      base="lstp"
      t={STANDARDS.lstp}
      readinessLabel="LSTP readiness"
      bonusIcon={Rocket}
      pdfName={`roots-nparks-lstp-${periodId}.pdf`}
      caveat={<>A readiness aid — <b>not an NParks certification or award</b>. It gauges how the contractor&apos;s operations align to the Landscape Sector Transformation Plan from the issued ROOTS evidence; audited sector-transformation schemes and grants are assessed by NParks separately.</>}
    />
  );
}
